module.exports = __webpack_public_path__ + "img/pie.6fff5f52.png";